import { Box, Link as MuiLink, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'
import { formatDateDMY } from '@/utils/date'
import type { WidgetProps } from './WidgetProps'
import { EmptyHint } from './EmptyHint'

interface TestRow {
  test_id: number
  lesson_id: number | null
  mode: string | null
  assigned_at: string | null
}

export function PendingTestsWidget({ payload }: WidgetProps) {
  const items = (payload.items ?? []) as TestRow[]
  const count = Number(payload.count ?? 0)

  if (count === 0) {
    return <EmptyHint fallbackKey="dashboard.widgets.pending_tests.empty" />
  }

  return (
    <Stack spacing={0.75}>
      {items.map((item) => (
        <Box key={item.test_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
          <MuiLink
            component={Link}
            to={ROUTES.TEST_RUN(item.test_id)}
            variant="body2"
            noWrap
            sx={{ flexGrow: 1, minWidth: 0 }}
          >
            #{item.test_id}
          </MuiLink>
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
            {formatDateDMY(item.assigned_at)}
          </Typography>
        </Box>
      ))}
      {count > items.length && (
        <Typography variant="caption" color="text.secondary">
          +{count - items.length}
        </Typography>
      )}
    </Stack>
  )
}
